<template>
    <div class="home-content">
        <div class="first-pard">
          <span></span>
          <span>Order</span>
          <div>
            <select v-model="timeType" @change="timeChange(timeType)">
              <option value="1" selected>Today</option>
              <option value="2">Yesterday</option>
              <option value="3">Last Week</option>
              <option value="4">Last Month</option>
              <option value="5">Last 3 Months</option>
              <option value="6">All Orders</option>
              <option value="7">Conditional Query</option>
            </select>
          </div>
        </div>
        <div class="second-pard">
            <ul>
              <li :class="status==1?'on':''" @click="changeNav(1)">Pending</li>
              <li :class="status==2?'on':''" @click="changeNav(2)">Closed</li>
              <li :class="status==3?'on':''" @click="changeNav(3)">Cancelled</li>
            </ul>
        </div>
        <div class="search-pard" v-show="timeType==7">
          <div class="screenContent">
            <ul>
              <li @click="showST">
                <span class="textleft">Start date</span>
                <span class="textRight" id="startTime">Select start time</span>
              </li>
              <li @click="showET">
                <span class="textleft">End date</span>
                <span class="textRight" id="endTime">Select end time</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="third-pard">
          <div v-show="!nodata">
            <div class="list" v-for="(i,index) in list" v-bind:key="index">
              <ul>
                <li class="des">
                  <div>Currency</div><div>{{i.currency.toUpperCase()}}/USDT</div>
                </li>
                <li class="des">
                  <div>Order No.</div>
                  <div>{{ i.order_no }}
                    <button v-clipboard:error="util.onError" v-clipboard:copy="i.order_no" v-clipboard:success="util.onCopy">Copy</button>  
                  </div>
                </li>
                <li class="des">
                  <div>Order Amount</div>
                  <div>{{i.bet_price}}</div>
                </li>
                <li class="des">
                  <div>Profit Amount</div>
                  <div v-if="i.money_win_loss>0" style="color:#f6543e; font-weight: bold;">{{i.money_win_loss}} </div>
                  <div v-else>{{i.money_win_loss}}</div>
                </li>
                <li class="des">
                    <div>Buy Direction</div>
                    <div style="color:#628808;" v-if="i.buy_up_down==1">Buy Up</div>
                    <div style="color:#f6543e;" v-else>Buy Down</div>
                </li>
                <li class="des">
                  <div>Scale</div><div>{{(i.odd-1).toFixed(2)*100 + '%'}}</div>
                </li>
                <li class="des">
                  <div>Billing Time</div><div>{{i.during_second}}s</div>
                </li>
                <!-- <li class="des" v-if="i.status==2">
                  <div>Actual Rise Fall</div>
                  <div>
                    <div v-if="i.close_price>i.buy_price"  style="color:#f6543e;">Rise</div>
                    <div v-if="i.close_price<i.buy_price"  style="color:#628808;">Fall</div>
                    <div v-if="i.close_price==i.buy_price"  style="color:orange;">No Change</div>
                  </div>
                </li> -->
                <li class="des">
                  <div>Order Time</div><div>{{util.formatTime(i.add_time)}}</div>
                </li>
              </ul>
              <div class="lookDetail">
                <!-- <button class="syt" v-if="i.status==1" @click="cancelOrder(i.id)">Cancel</button> -->
                <a @click="lookDetail(i)"><img src="@/assets/images/base/icon_righ_g.png"/></a>
              </div>
            </div>
          </div>
          <div class="nodata" v-show="nodata"><img src="@/assets/images/icon/data_icon_219962.png"/><span>No data available</span></div>
          <div class="show-more" v-if="list.length>=10" @click="showMore()">{{hasMore?"See more records, click here":"No more data"}}</div>
        </div>
        <div class="detail-pard" v-if="isDetail">
          <div class="detail-head">
            <div @click="lookList()"><img src="@/assets/images/base/icon_righ_g.png"/></div>
            <div>Order Detail</div>
            <div></div>
          </div>
          <div class="detail-content">
            <ul>
              <li class="des">
                <div>Order No.</div>
                <div>{{ one.order_no }}
                  <button v-clipboard:error="util.onError" v-clipboard:copy="one.order_no" v-clipboard:success="util.onCopy">Copy</button>  
                </div>
              </li>
              <li class="des">
                <div>Currency</div><div>{{one.currency.toUpperCase()}}/USDT</div>
              </li>
              <li class="des">
                <div>Buy Price</div><div>{{one.buy_price}}</div>
              </li>
              <li class="des">
                <div>Close Price</div><div v-if="one.status==2">{{one.close_price}}</div>
              </li>
              <li class="des">
                <div>Buy Time</div><div>{{util.formatTime(one.open_time)}}</div>
              </li>
              <li class="des">
                <div>Close Time</div><div v-if="one.status==2">{{util.formatTime(one.close_time)}}</div>
              </li>
              <li class="des">
                <div>Billing Time</div><div>{{one.during_second}}s</div>
              </li>
              <li class="des">
                <div>Order Amount</div><div>{{one.bet_price}}</div>
              </li>
              <li class="des">
                <div>Order Status</div>
                <div>
                  <span v-if="one.status==1" style="color:#1087e7;">Pending</span>
                  <span v-if="one.status==2" style="color:#628808;">Closed</span>
                  <span v-if="one.status==3" style="color:#f6543e;">Cancelled</span>
                </div>
              </li>
              <li class="des">
                <div>Profit Amount</div>
                <div v-if="one.money_win_loss>0" style="color:#f6543e; font-weight: bold;">{{one.money_win_loss}}</div>
                <div v-else>{{one.money_win_loss}}</div>
              </li>
              <li class="des">
                <div>Scale</div><div>{{(one.odd-1).toFixed(2)*100 + '%'}}</div>
              </li>
              <li class="des">
                <div>Buy Direction</div>
                <div style="color:#628808;" v-if="one.buy_up_down==1">Buy Up</div>
                <div style="color:#f6543e;" v-else>Buy Down</div>
              </li>
              <li class="des" v-if="one.status==2">
                <div>Actual Rise Fall</div>
                <div>
                  <div v-if="one.close_price>one.buy_price"  style="color:#f6543e;">Rise</div>
                    <div v-if="one.close_price<one.buy_price"  style="color:#628808;">Fall</div>
                    <div v-if="one.close_price==one.buy_price"  style="color:orange;">No Change</div>
                </div>
              </li>
              <li class="des">
                <div>Order Time</div><div>{{util.formatTime(one.add_time)}}</div>
              </li>
            </ul>
          </div>
        </div>
        <FootMenu/>
        <van-loading v-show="showloding" size="50px" color="#1989fa" vertical/>
    </div>
    </template>
    <script>
    /*global mui*/
    import Vue from "vue";
    import { Loading } from "vant";
    import VueClipboard from "vue-clipboard2";
    Vue.use(VueClipboard);
    Vue.use(Loading);
    import Rolldate from "rolldate";
    import FootMenu from "@/coms/footmenu.vue";
    export default {
      components:{
        FootMenu
      },
      data() {
        return {
          showloding: true,
          timeType:1,
          addTime:this.util.todayTime(1),
          nodata:true,
          status:1,
          pageNo:1,
          pageSize:10,
          hasMore:true,
          list:[],
          isDetail:false,
          one:{},
          ST: 0,
          ET: 0
        };
      },
      methods: {
        showST() {
          let _this = this;
          let rd = new Rolldate({
            el: "#startTime",
            format: "YYYY/MM/DD",
            beginYear: 2000,
            endYear: 2100,
            minStep: 1,
            lang: { 
              cancel: 'Cancel', 
              title: "Select start time",
              confirm: "Confirm",
              year: "",
              month: "",
              day: ""
            },
            trigger: "tap",
            confirm: function(date) {
              date = date + " 00:00:00";
              _this.ST = (Date.parse(date) / 1000).toFixed(0);
              if (_this.ET > 0 && _this.ST > _this.ET) {
                mui.toast("Start time cannot be greater than end time");
              }else{
                _this.timeBetweenSearch();
              }
            }
          });
          rd.show();
        },
        showET() {
          let _this = this;
          let rd = new Rolldate({
            el: "#endTime",
            format: "YYYY/MM/DD",
            beginYear: 2000,
            endYear: 2100,
            minStep: 1,
            lang: { 
              cancel: 'Cancel', 
              title: "Select start time",
              confirm: "Confirm",
              year: "",
              month: "",
              day: ""
            },
            trigger: "tap",
            confirm: function(date) {
              date = date + " 23:59:59";
              _this.ET = (Date.parse(date) / 1000).toFixed(0);
              if (_this.ST > 0 && _this.ST > _this.ET) {
                mui.toast("Start time cannot be greater than end time");
              }else{
                _this.timeBetweenSearch();
              }
            }
          });
          rd.show();
        },
        lookList(){
          this.changeNav(this.status);
          this.isDetail = false;
        },
        lookDetail(i){
          this.one = i;
          this.isDetail = true;
          this.oneOrder(i.id);
        },
        oneOrder(id){
          let params = {orderId:id}
          this.util.setDnValueToken(params);
          this.axios.get(this.api.api_getOneOrder, {params: params}) .then(res => {
              if (res.data.code == 0) {
                this.one = res.data.data;
              } else {
                this.util.checkToken(res.data.message);
              }
            });
        },
        changeNav(sts){
          this.status = sts;
          this.timeChange(this.timeType);
        },
        timeBetweenSearch() {
          this.addTime.startTime = this.ST;
          this.addTime.endTime =  this.ET;
          this.hasMore = true;
          this.pageNo = 1;
          this.list = [];
          this.getOrder();
        },
        timeChange(type){
          if(type==7){
            this.ST = 0;
            this.ET = 0;
            this.addTime.startTime = 0;
            this.addTime.endTime = 0;
            document.getElementById("startTime").innerHTML="";
            document.getElementById("endTime").innerHTML="";
          }else{
            this.addTime = this.util.todayTime(type);
          }
          this.hasMore = true;
          this.pageNo = 1;
          this.list = [];
          this.getOrder();
        },
        showMore(){
          if(this.hasMore){
            this.pageNo += 1;
            this.getOrder();
          }
        },
        getOrder() {
          this.showloding = true;
          let params = {
            winStatus:0,
            status:this.status,
            startTime:this.addTime.startTime,
            endTime:this.addTime.endTime,
          }
          this.util.setDnValueToken(params);
          params.userId = this.util.user.id;
          params.pageNo = this.pageNo;
          params.pageSize = this.pageSize;
          this.axios.get(this.api.api_getOrder, {params: params}) .then(res => {
              if(this.pageNo==1) this.nodata = true;
              this.showloding = false;
              if (res.data.code == 0) {
                let list = res.data.data;
                if(list.length>0) {
                  this.nodata = false;
                  this.list = this.list.concat(list);
                }else{
                  this.hasMore = false;
                }
              } else {
                this.util.checkToken(res.data.message);
              }
            });
        },
        cancelOrder(id) {
          let thisPage = this;
          mui.confirm("Are you sure you want to cancel this order?", "Hint", ["No", "Yes"], function (e) {
            if (e.index == 1) {
              thisPage.cancelOrderConfirm(id);
            } else {
              mui.confirm();
            }
          });
        },
        cancelOrderConfirm(id){
          this.cheackpass = false;
          let params = {orderId :id};
          this.util.setDnValueToken(params);
          this.axios.post(this.api.api_cancelOrder, this.util.encodeSearchParams(params)).then((res) => {
              this.cheackpass = true;
              if (res.data.code == 0) {
                this.changeNav(1);
                mui.alert("The order was withdrawn successfully");
              } else {
                mui.alert(res.data.message);
              }
            })
            .catch(() => {
              this.cheackpass = true;
              mui.alert("Your current network is unstable. Please optimize the network.");
            });
        }
      },
      activated(){
        if(this.util.isLogin()){
          this.addTime = this.util.todayTime(1),
          this.changeNav(1);
        }
      }
    };
    </script>
    <style lang="scss" scoped>
    .home-content{
      font-size: 0.32rem;
      background: rgb(235, 235, 235);
      color:rgb(103, 103, 103);
      width: 100%;
      height: 100%;
      .first-pard{
        height: 36px;
        display: grid;
        grid-template-columns: 30% 1fr 30%;
        align-items: center;
        font-size: 0.34rem;
        text-align: center;
        font-weight: bold;
        color:black;
        :nth-child(1){
          cursor: pointer;
          margin-left: 6%;
          img{
            display: block;
            width: 18px;
            transform: rotate(180deg);
          }
        }
        select {
          cursor: pointer;
          background: rgb(235, 235, 235);
          height: 36px;
          font-size: 0.32rem;
          font-weight: normal;
          text-align: center;
          width: 90px;
          option{
            font-size: 0.3rem;
            text-align: right;
          }
        }
      }
      .second-pard{
        background-color: white;
        ul{
          display: flex;
          justify-content: center;
          align-items: center;
          li{
            font-size: 0.32rem;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 40px;
            width: 33.3%;
            border-bottom:1px solid rgb(212, 212, 212);
          }
          .on{
            font-weight: bold;
            border-bottom:3px solid #628808;
          }
        }
      }
      .third-pard{
        height: 100%;
        padding-bottom: 228px;
        overflow-y: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;
        .nodata{
          margin-top: 50px;
          height: 50px;
          display: grid;
          justify-content: center;
          font-size: 0.32rem;
          img{
            display: block;
            width: 35px;
            margin: auto;
          }
        }
        .show-more{
          height: 50px;
          display: flex;
          cursor: pointer;
          justify-content: center;
          align-items: center;
        }
        .list{
          width: 97%;
          display: grid;
          grid-template-columns: 1fr 2%;
          align-items: center;
          margin:10px auto;
          border-radius: 10px/10px;
          background-color: white;
          padding: 10px 20px;
          font-size: 0.32rem;
          .des{
            display: grid;
            grid-template-columns: 40% 60%;
            padding: 1px 0;
            font-size: 0.32rem;
            :nth-child(1){
                font-weight: bold;
              }
           }

           button {
            float: right;
            padding-right: 0px;
            color: brown;
          }
          
        }
        .lookDetail{
          img{
            display: block;
            margin: auto;
            width: 18px;
          }
          .syt {
            background: #628808;
            color: white;
            float: right;
            margin-right: 5px;
            padding: 0 5px;
          }
        }
      }

      .search-pard{
        .van_picker{
          background-color: rgb(164, 194, 219);
          width:100%;
          border-radius: 10px/10px;
        }
    
        .screenContent {
          width: 100%;
          height: 100%;
          overflow-y: auto;
          padding-top: 0.2rem;
          ul {
            width: 100%;
            height: auto;
            background: #ffffff;
            padding: 0 0.3rem;
            li {
              width: 100%;
              height: 1rem;
              border-bottom: 1px solid #e8e5e5;
              // background: url(images/goRight.png)
                // no-repeat center right;
              background-size: 0.5rem 0.5rem;
              font-size: 0.34rem;
              line-height: 1rem;
              color: #000000;
              padding-right: 0.7rem;
              position: relative;
              #trigger {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                z-index: 2;
              }
              .textleft {
                display: flex;
                justify-content: left;
                align-items: center;
              }
              .textRight {
                width: 100%;
                position: absolute;
                top: 50%;
                right: 0.7rem;
                transform: translateY(-50%);
                text-align: right;
                font-size: 0.34rem;
                padding: 0;
                color: #333333;
                line-height: 0.4rem;
              }
            }
            :last-child{
              border-bottom: 0;
            }
          }
        }
      }
    
      .detail-pard{
        position: absolute;
        left: 0;
        right: 0;
        top:0;
        bottom: 50px;
        z-index: 1;
        background: rgb(235, 235, 235);
        .detail-head{
          height: 50px;
          display: grid;
          grid-template-columns: 30% 1fr 30%;
          align-items: center;
          text-align: center;
          font-size: 0.34rem;
          :nth-child(1){
            cursor: pointer;
            img{
              display: block;
              margin-left: 5%;
              width: 18px;
              transform: rotate(180deg);
            }
          }
        }
        .detail-content{
          ul{
            width: 97%;
            margin:0 auto;
            border-radius: 10px/10px;
            background-color: white;
            padding: 10px 20px;
            font-size:14px;
            .des{
              display: grid;
              grid-template-columns: 40% 60%;
              padding: 1px 0;
              font-size:14px;
              :nth-child(1){
                font-weight: bold;
              }
            }

            button {
              float: right;
              padding-right: 0px;
              color: brown;
            }
          }
        }
      }
    }
    </style>  